(() => {
  if (customElements.get('ch-layer-explorer')) return;
  customElements.define('ch-layer-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.buttons = [...this.querySelectorAll('[data-layer-select]')];
      this.panels = [...this.querySelectorAll('[data-layer-panel]')];
      this.shapes = [...this.querySelectorAll('[data-layer-shape]')];
      if (!this.buttons.length || this.buttons.length !== this.panels.length) return;
      this.select(0);
      this.setAttribute('data-layers-ready', '');
      this.querySelectorAll('.ch-layers__buttons, [data-layer-toggle], [data-layer-hint]').forEach(el => { el.hidden = false; });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-layer-select]');
        const shape = event.target.closest('[data-layer-shape]');
        if (button) this.select(Number(button.dataset.layerSelect));
        else if (shape) this.select(Number(shape.dataset.layerShape));
        else if (event.target.closest('[data-layer-toggle]')) {
          const toggle = this.querySelector('[data-layer-toggle]');
          const closed = this.toggleAttribute('data-layers-closed');
          toggle.setAttribute('aria-expanded', String(!closed));
          toggle.textContent = closed ? toggle.dataset.expandLabel : toggle.dataset.collapseLabel;
        }
      }, options);
      this.addEventListener('keydown', event => {
        const button = event.target.closest('[data-layer-select]');
        if (!button) return;
        const index = this.buttons.indexOf(button);
        const keys = { ArrowRight: (index + 1) % this.buttons.length, ArrowDown: (index + 1) % this.buttons.length, ArrowLeft: (index - 1 + this.buttons.length) % this.buttons.length, ArrowUp: (index - 1 + this.buttons.length) % this.buttons.length, Home: 0, End: this.buttons.length - 1 };
        if (!(event.key in keys)) return;
        event.preventDefault();
        this.select(keys[event.key]);
        this.buttons[keys[event.key]].focus();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        if (event.detail?.sectionId !== this.dataset.sectionId) return;
        const index = this.buttons.findIndex(button => button.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.select(index);
      }, options);
    }
    select(index) {
      if (!this.buttons[index]) return;
      this.buttons.forEach((el, i) => el.setAttribute('aria-pressed', String(i === index)));
      this.panels.forEach((el, i) => { el.classList.toggle('is-active', i === index); el.setAttribute('aria-hidden', String(i !== index)); });
      this.shapes.forEach(el => el.classList.toggle('is-active', Number(el.dataset.layerShape) === index));
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
})();
